<template>
    <Head title="Liste des expéditions" />

    <AppLayout>
        <div x-data="handleSelect">
            <Datatables>
                <template #title>
                    Liste des expéditions
                    <span class="font-medium">({{ travels.total }})</span>
                </template>
    
                <template #headerButtons>
                    <button class="rounded-md py-1 px-2 bg-white text-sky hover:bg-sky-400 hover:text-white mr-3"
                        @click="showSearchModal" title="Rechercher"
                    >
                        <i  class="fad fa-search"></i>
                    </button>
                    <button v-if="$page.props.acl.isAdmin || $page.props.acl.isCommercial"
                        class="rounded-md py-1 px-2 bg-white text-sky hover:bg-sky-400 hover:text-white"
                        @click="showModal()" title="Ajouter une expédition"
                    >
                        <i class="fad fa-plus-circle"></i>
                    </button>
                </template>
    
                <template #tableHeader>
                    <th>#</th>
                    <th>Référence</th>
                    <th>Départ</th>
                    <th>Arrivée</th>
                    <th>Début collecte</th>
                    <th>Fin collecte</th>
                    <th># Colis</th>
                    <th># Articles</th>
                    <th width="7%">Statut</th>
                    <th width="3%">&nbsp;</th>
                </template>
    
                <template #tableBody>
                    <tr v-for="(travel, index) in travels.data" :key="travel.id">
                        <td>{{ index + 1 }}</td>
                        <td>{{ travel.reference }}</td>
                        <td class="capitalize">
                            {{ formattedDate(travel.departure_date)+' | '+travel.departure_country.name }}
                        </td>
                        <td class="capitalize">
                            {{ formattedDate(travel.arrival_date)+' | '+travel.arrival_country.name }}
                        </td>
                        <td class="capitalize">{{ formattedDate(travel.collection_start_at) }}</td>
                        <td class="capitalize">{{ formattedDate(travel.collection_end_at) }}</td>
                        <td>{{ travel.packages_count }}</td>
                        <td>{{ travel.items_count }}</td>
                        <td><StatusBadge :label="travel.status_text" :color="travel.status_color" /></td>
                        <td>
                            <div class="flex justify-end items-center space-x-3">
                                <i v-if="travel.packages_count === 0 && travel.items_count === 0 && ($page.props.acl.isAdmin || $page.props.acl.isCommercial)" @click="showModal(travel)"
                                    class="fad fa-pen-alt text-sky hover:text-sky-700 cursor-pointer" title="Modifier"
                                ></i>
                                <i v-else class="fad fa-pen-alt text-gray-500 opacity-50 cursor-not-allowed" title="Impossible de modifier"></i>
    
                                <i v-if="$page.props.acl.isAdmin && travel.packages_count === 0 && travel.items_count === 0" @click="destroyTravel(travel)"
                                    class="fad fa-trash text-red-500 hover:text-red-600 cursor-pointer" title="Supprimer"
                                ></i>
                                <i v-else class="fad fa-trash text-gray-500 opacity-50 cursor-not-allowed" title="Impossible de supprimer"></i>
    
                                <Link :href="searchByCode ? (route('travels.packages.index', travel) +'?filter[code]='+ searchByCode) : route('travels.show', travel)" title="Détails">
                                    <svg class="shrink-0 h-6 w-6" viewBox="0 0 24 24">
                                        <path class="fill-current text-sky" d="M8.07 16H10V8H8.07a8 8 0 110 8z"></path>
                                        <path class="fill-current text-sky-300" d="M15 12L8 6v5H0v2h8v5z"></path>
                                    </svg>
                                </Link>
                            </div>
                        </td>
                    </tr>
                </template>
            </Datatables>
        </div>

        <Pagination :links="travels.links" />

        <JetDialogModal :show="searchModal" @close="closeSearchModal" max-width="xl">
            <template #title>Rechercher une expédition</template>

            <template #content>
                <GlobalFilter @search-launched="closeSearchModal" />
            </template>
        </JetDialogModal>

        <JetDialogModal :show="manageModal" @close="closeModal" max-width="2xl">
            <template #title> {{ travel ? 'Modifier l\'expédition N°'+travel.reference : 'Ajouter une nouvelle expédition'}}</template>

            <template #content>
                <div class="grid grid-cols-2 gap-4">
                    <div class="col-span-1 sm:col-span-1">
                        <JetLabelRequired for="departure_date" value="Date de départ" />
                        <JetInput v-model="form.departure_date" type="date" />
                        <JetInputError :message="form.errors.departure_date" />
                    </div>
                    <div class="col-span-1 sm:col-span-1">
                        <JetLabelRequired for="arrival_date" value="Date d'arrivée" />
                        <JetInput v-model="form.arrival_date" type="date"  />
                        <JetInputError :message="form.errors.arrival_date" />
                    </div>
                    <div class="col-span-1 sm:col-span-1">
                        <JetLabelRequired for="collection_start_at" value="Date de début de la collecte" />
                        <JetInput v-model="form.collection_start_at" type="date" />
                        <JetInputError :message="form.errors.collection_start_at" />
                    </div>
                    <div class="col-span-1 sm:col-span-1">
                        <JetLabelRequired for="collection_end_at" value="Date de fin de la collecte" />
                        <JetInput v-model="form.collection_end_at" type="date" />
                        <JetInputError :message="form.errors.collection_end_at" />
                    </div>
                </div>
                <div class="grid grid-cols-2 gap-4 mt-2">
                    <div class="col-span-1 sm:col-span-1">
                        <JetLabel for="container_company" value="Compagnie maritime:" />
                        <JetInput id="container_company" type="text" autocomplete="off"
                            v-model="form.container_company" placeholder="Entrer la compagnie maritime"
                        />
                        <JetInputError :message="form.errors.container_company" />
                    </div>
                    <div class="col-span-1 sm:col-span-1">
                        <JetLabel for="container_size" value="Taille du conteneur:" />
                        <JetInput id="container_size" type="number" class="text-right"
                            min="0" v-model="form.container_size" placeholder="0"
                        />
                        <JetInputError :message="form.errors.container_size" />
                    </div>
                </div>
                <div class="grid grid-cols-2 gap-4 mt-2">
                    <div class="col-span-1 sm:col-span-1">
                        <JetLabelRequired for="departure_country_id" value="Pays de départ" />
                        <Multiselect
                            :searchable="true"
                            :options="countries"
                            v-model="form.departure_country_id"
                            placeholder="Sélectionner le pays de départ"
                        />
                        <JetInputError :message="form.errors.departure_country_id" />
                    </div>
                    <div class="col-span-1 sm:col-span-1">
                        <JetLabelRequired for="arrival_country_id" value="Pays d'arrivée" />
                        <Multiselect
                            :searchable="true"
                            :options="countries"
                            v-model="form.arrival_country_id"
                            placeholder="Sélectionner le pays d'arrivée"
                        />
                        <JetInputError :message="form.errors.arrival_country_id" />
                    </div>
                </div>
                <div class="grid grid-cols-2 gap-4 mt-2">
                    <div class="col-span-2">
                        <JetLabel for="warehouse_id" value="Entrepôt de stockage à l'arrivée:" />
                        <Multiselect
                            :searchable="true"
                            :options="warehouses"
                            v-model="form.warehouse_id"
                            placeholder="Sélectionner l'entrepôt de stockage à l'arrivée"
                        />
                        <JetInputError :message="form.errors.warehouse_id" />
                    </div>
                </div>
                <div class="grid grid-cols-1 gap-4 mt-2">
                    <div class="col-span-1">
                        <JetLabel for="clauses" value="Clauses d'expédition:" />
                        <textarea
                            id="clauses"
                            class="form-input w-full"
                            rows="10"
                            v-model="form.clauses"
                            placeholder="Clauses BOTI Cargo Shipping..."
                        ></textarea>
                        <JetInputError :message="form.errors.clauses" />
                    </div>
                </div>
            </template>

            <template #footer>
                <BotiButton @click="closeModal" text="Quitter" color="red">
                    <template #icon><i class="fad fa-times-circle text-sm ml-1"></i></template>
                </BotiButton>

                <BotiButton v-if="travel" :loader="form.processing" :disabled="form.processing"
                    @click="updateTravel()" text="Modifier"
                    color="sky" class="ml-2" :class="{ 'opacity-25': form.processing }"
                >
                    <svg v-if="form.processing" class="animate-spin w-4 h-4 fill-current shrink-0" viewBox="0 0 16 16">
                        <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z"></path>
                    </svg>
                    <template #icon>
                        <i class="fad fa-user-edit text-sm ml-1"></i>
                    </template>
                </BotiButton>

                <BotiButton v-else :loader="form.processing" :disabled="form.processing"
                    @click="storeTravel()" text="Enregistrer"
                    class="ml-2" :class="{ 'opacity-25': form.processing }"
                >
                    <svg v-if="form.processing" class="animate-spin w-4 h-4 fill-current shrink-0" viewBox="0 0 16 16">
                        <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z"></path>
                    </svg>
                    <template #icon>
                        <i class="fad fa-check-circle text-sm ml-1"></i>
                    </template>
                </BotiButton>
            </template>
        </JetDialogModal>
    </AppLayout>
</template>

<script>
    import { defineComponent } from 'vue'
    import JetLabel from '@/Jetstream/Label'
    import JetInput from '@/Jetstream/Input'
    import BotiButton from '@/Components/Button'
    import Multiselect from '@vueform/multiselect'
    import AppLayout from '@/Layouts/AppLayout.vue'
    import Datatables from '@/Components/Datatables'
    import Pagination from '@/Components/Pagination'
    import StatusBadge from '@/Components/StatusBadge'
    import JetInputError from '@/Jetstream/InputError'
    import { Head, Link } from '@inertiajs/inertia-vue3'
    import JetDialogModal from '@/Jetstream/DialogModal'
    import GlobalFilter from '@/Components/GlobalFilter'
    import JetLabelRequired from '@/Jetstream/LabelRequired'
    import DateFormatMixins from '@/Mixins/DateFormatMixins'

    export default defineComponent({
        components: {
            Head,
            Link,
            JetLabel,
            JetInput,
            AppLayout,
            Datatables,
            Pagination,
            BotiButton,
            StatusBadge,
            Multiselect,
            GlobalFilter,
            JetInputError,
            JetDialogModal,
            JetLabelRequired
        },

        props: {
            travels: Object,
            countries: Object,
            warehouses: Object,
            searchByCode: String,
            defaultClauses: {
                type: String,
                default: '',
            },
        },

        mixins: [DateFormatMixins],

        data() {
            return {
                manageModal: false,
                searchModal: false,
                travel: null,
                form: this.$inertia.form({})
            }
        },

        methods: {
            closeModal() {
                this.manageModal = false
                this.form.clearErrors()
                this.form.reset()
            },

            showModal(travel) {
                 if (travel) {
                    this.travel = travel

                    this.form = this.$inertia.form({
                        departure_date: this.formattedDate(this.travel.departure_date, "YYYY-MM-DD"),
                        arrival_date: this.formattedDate(this.travel.arrival_date, "YYYY-MM-DD"),
                        collection_start_at: this.formattedDate(this.travel.collection_start_at, "YYYY-MM-DD"),
                        collection_end_at: this.formattedDate(this.travel.collection_end_at, "YYYY-MM-DD"),
                        departure_country_id: this.travel.departure_country_id,
                        arrival_country_id: this.travel.arrival_country_id,
                        container_size: this.travel.container_size,
                        container_company: this.travel.container_company,
                        warehouse_id: this.travel.warehouse_id ? this.travel.warehouse_id : null,
                        clauses: this.travel.clauses || this.defaultClauses
                    })

                } else {
                    this.warehouse = null
                    this.form = this.$inertia.form({
                        departure_date: null,
                        arrival_date: null,
                        collection_start_at: null,
                        collection_end_at: null,
                        departure_country_id: null,
                        arrival_country_id: null,
                        container_size: null,
                        container_company: null,
                        warehouse_id: null,
                        clauses: this.defaultClauses
                    })
                }

                this.form.clearErrors()
                this.manageModal = true
            },

            showSearchModal () {
                this.searchModal = true
            },

            closeSearchModal() {
                this.searchModal = false
                this.form.clearErrors()
            },

            storeTravel() {
                this.form.post(route('travels.store'), {
                    preserveScroll: true
                })
            },

            updateTravel() {
                this.form.put(route('travels.update', {'travel': this.travel}), {
                    preserveScroll: true,
                    reserveState: true,

                    onSuccess: () => {
                        this.$swal.fire(
                            'Expédition',
                            'Expédition modifié avec succès.',
                            'success'
                        )
                        this.closeModal()
                    },

                    onError: (error) => {
                    }
                })
            },

            destroyTravel(travel) {
                this.$swal.queue([{
                    title: "Expédition",
                    text: "Etes vous sûr de vouloir supprimer l'expédition ?",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: 'rgb(241, 162, 0)',
                    cancelButtonColor: '#bd081c',
                    confirmButtonText: "Supprimer",
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return this.$inertia.delete(route('travels.destroy', {'travel': travel}), {
                            preserveScroll: true,
                            preserveState: true,
                            onSuccess: () => {
                                this.$swal.fire(
                                    'Expédition',
                                    'Expédition supprimé avec succès.',
                                    'success'
                                )
                            },
                            onError: (error) => {
                                this.$swal.fire({
                                    icon: 'error',
                                    title: error.message
                                })
                            }
                        })
                    }
                }])
            }
        }
    })
</script>
